module.exports = __webpack_public_path__ + "static/media/22.a4c01b4d.svg";